import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL, BASE_LOGIN_API_URL } from "../utility/URL";


const groupList = async () => {
    const response = await axios
        .post(BASE_API_URL + "account/accountgroup",{}, headerConfig);
    return response;
};



const groupService = {
    groupList,
    
 
};

export default groupService;